export const indexManufacturersSliderOptions = (instance, options) => {
    
        let responsiveItemCounts = {
            1000: 8,
        }
        let breakpoints = {}
        for (const resolution in responsiveItemCounts) {
            const count = responsiveItemCounts[resolution]
            breakpoints[resolution] = {
                loop: false,
                slidesPerView: count,
                slidesPerGroup: count,
                spaceBetween: 24,
                cssMode: false,
            }
        }
        return {
            loop: false,
            slidesPerView: "auto",
            slidesPerGroup: 2,
            spaceBetween: 10,
            cssMode: false,
            breakpoints: breakpoints,
            pagination: {
                el: instance.paginationEl,
                clickable: true,
                hideOnClick: false,          
            },
        }
    }
